// Real-mode Retry-Processor fetcher — swap-in for getRetryProcessorMock() (task [2.5]).
// Relative path; the installed fetch-patch handles VITE_API_URL prefixing, the
// MSAL bearer, and non-2xx rejection. See overview/real.ts header for the full
// contract + the untested-against-real-backend caveat (proposal risk table).

import { z } from 'zod';

import { statTileSchema } from '@/api/schemas';
import type { RetryProcessorData } from './mock';

const retryStatusSchema = z.enum([
	'retrying',
	'succeeded',
	'exhausted',
	'pending',
]);

const retryAttemptSchema = z.object({
	id: z.string(),
	recipient: z.string(),
	provider: z.string(),
	status: retryStatusSchema,
	attempt: z.number(),
	maxAttempts: z.number(),
	errorReason: z.string(),
	lastAttempt: z.string(),
	nextRetry: z.string().nullable(),
});

const retryProcessorDataSchema = z.object({
	statTiles: z.array(statTileSchema),
	attempts: z.array(retryAttemptSchema),
});

export async function getRetryProcessor(): Promise<RetryProcessorData> {
	const response = await fetch('/retry-processor');
	const json: unknown = await response.json();
	return retryProcessorDataSchema.parse(json);
}
